import Collapse from "@solundo/webshop/js/Collapse";
import NumberInput from "@solundo/webshop/js/NumberInput/NumberInput";
import Events from "@wwdev/bootstrap/Events";

class Cart {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-cart="scope"]',
			amount: '[data-cart="amount"]',
			remove: '[data-cart="remove"]',
			pricingWrapper: '[data-cart="pricing_wrapper"]',
			discountWrapper: '[data-cart="discount_wrapper"]',
			discountForm: '[data-cart="discount_form"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
		this._initPackages();
	}

	addEventListeners() {
		this.$scope.on('click', this.config.remove, this.removeItem.bind(this));
		this.$scope.on('change', this.config.amount, this.updateQuantity.bind(this));
		this.$scope.on('submit', this.config.discountForm, this.addDiscount.bind(this));
	}

	removeItem(event) {
		event.preventDefault();
		let $button = $(event.currentTarget);
		if(!confirm($button.data('confirm'))) {
			return;
		}
		this._doRequest({
			action: 'remove_item',
			key: $button.data('key'),
		});
	}

	updateQuantity(event) {
		let $input = $(event.currentTarget);

		// Timeout is per input,
		// dit is om te voorkomen dat als ik een ander input wijzig dat de timeout gecleared wordt,
		$input.data('timeout') ? clearTimeout($input.data('timeout')) : null;
		$input.data('timeout', setTimeout(() => {
			let data = {
				action: 'update_quantity',
				lineItem: $input.data('line-item'),
				option: $input.data('option'),
				key: $input.data('key'),
				amount: $input.val()
			};
			this._doRequest(data);
		}, 400));
	}

	addDiscount(event) {
		event.preventDefault();
		let $form = $(event.currentTarget);
		$form.find('button').attr('disabled', true);

		let $input = $form.find('.discount-input');
		this._doRequest({
			action: 'add_discount',
			discountcode: $input.val()
		}, 'post', null, this._refreshDiscountForm.bind(this));
	}

	_doRequest(data, method = 'post', url = null, callback = null) {
		if(!url) {
			url = location.pathname;
		}

		if(!callback) {
			callback = this._onSuccess.bind(this);
		}

		$.ajax({
			url: url,
			method: method,
			data: data,
			success: callback
		})
	}

	_onSuccess(response) {
		location.reload();
	}

	_refreshDiscountForm(response) {
		let $response = $(response.html);
		this.$scope.find(this.config.pricingWrapper).html($response.find(this.config.pricingWrapper).html());
		this.$scope.find(this.config.discountWrapper).html($response.find(this.config.discountWrapper).html());
		Events.trigger('wwdev.winkelwagen.indicator.refresh');
	}

	_initPackages() {
		// Hier komen alle packages / components;
		// Bij een ajax functie kun je vervolgens deze functie weer aanroepen om event listeners etc. toetevoegen.
		new Collapse({
			group: `${this.config.scope}`,
			namespace: 'filters-collapse'
		});

		new NumberInput({
			scope: `${this.config.scope} [data-number="scope"]`
		});
	}
}

export default new Cart;